module.exports = __webpack_public_path__ + "img/no_data.488cc5a7.svg";